module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2112761"
    }
  }, [_c('b', [_vm._v("HONEYDEW AND LIME SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2113261"
    }
  }, [_c('b', [_c('i', [_vm._v("This chilled soup starts a summer meal off with a refreshing mix of surprising flavors. Choose a melon that is fully ripe for a smooth consistency.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2114561"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes, plus chilling")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2115161"
    }
  }, [_vm._v("1 honeydew melon (5 pounds), chilled, "), _c('br'), _vm._v(" cut into 1-inch chunks (8 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2115761"
    }
  }, [_vm._v("¼ cup fresh lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2116661"
    }
  }, [_vm._v("¼ cup loosely packed fresh cilantro leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2117661"
    }
  }, [_vm._v("1 teaspoon jalapeño hot sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2118261"
    }
  }, [_vm._v("⅛ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2119361"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In blender, pulse melon with lime juice, cilantro, hot sauce, and salt until pureed. Transfer soup to large bowl or pitcher; cover and refrigerate 2 hours or until chilled. Stir before serving. Makes about 6 cups or 6 servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2121561"
    }
  }, [_vm._v("Each serving: About 85 calories, 1g protein, 23g carbohydrate, 0g total fat, 2g fiber, 0mg cholesterol, 80mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219be607","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c60_r1.vue
// module id = 246
// module chunks = 0